import { ACCLAIMED_DINING } from '../../assets/copy';

export const TAGS = Object.freeze({ ACCLAIMED_DINING });
